import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCheckboxIdle(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M20 4v16H4V4h16Zm-.222-2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="currentColor"
        fillOpacity=".4"
      />
    </BaseIcon>
  );
}
